export const createVolumeController = (sourceTrack: MediaStreamTrack) => {
  const audioContext = new AudioContext(); // AudioContext for audio processing
  const gainNode = audioContext.createGain(); // GainNode to control the volume

  const mediaStream = new MediaStream([sourceTrack]); // Wrap the source track in a MediaStream

  const sourceNode = audioContext.createMediaStreamSource(mediaStream);

  sourceNode.connect(gainNode); // Connect the source node to the gain node

  const destinationNode = audioContext.createMediaStreamDestination();

  gainNode.connect(destinationNode); // Connect the gain node to the destination node

  const resultingStream = destinationNode.stream; // Extract the resulting MediaStream

  let previousVolume = 0;
  const setVolume = (volume: number): void => {
    const clampedVolume = Math.max(0, Math.min(100, volume));
    if (clampedVolume === previousVolume) {
      return;
    }
    previousVolume = clampedVolume;
    // console.warn('VolumeController setVolume', volume);
    gainNode.gain.setValueAtTime((clampedVolume / 100) * 2, audioContext.currentTime);
  };
  setVolume(50); // Set volume to 100% real value by default

  return {
    setVolume,
    resultingStream,
    audioContext,
  };
};
